import { useEffect, useState } from "react";
import { supabase } from "../lib/supabase";
import type { PickedMovement } from "../lib/reviewerWeek";

/* THE REVIEWER'S OWN LIBRARY, READ ONLY — the movements he can add or swap into a proposed week (reviewer seat step 2).
 * His own `coach_exercises` rows through their RLS (`coach_id` = him); a READ of his library, never of the client's coach's.
 * 🔴 THIS FILE ONLY SELECTS — the ruler `reviewerSeatNoCoachWrite.test.ts` holds it to that. */
export function useMyLibraryNames(): PickedMovement[] {
  const [rows, setRows] = useState<PickedMovement[]>([]);
  useEffect(() => {
    let cancelled = false;
    void (async () => {
      const me = (await supabase.auth.getUser()).data.user?.id;
      if (me === undefined) return;
      const r = await supabase.from("coach_exercises").select("id, name, tracking_fields").eq("coach_id", me).is("hidden_at", null).order("name");
      if (!cancelled && r.error === null) {
        setRows((r.data ?? []).map((x) => ({ exercise_id: x.id, name: x.name, tracking_fields: x.tracking_fields ?? null })));
      }
    })();
    return () => { cancelled = true; };
  }, []);
  return rows;
}
